import ensureGoogleAnalytics from '../ensureGoogleAnalytics.js';
export default async function sendImpressions(_ref, data, options) {
  let {
    history
  } = _ref;
  await ensureGoogleAnalytics(options, dataLayer => {
    dataLayer.push({
      event: 'analytics_event',
      eventAction: 'impression',
      eventNonInteractive: true,
      eventData: {},
      ...data
    });
  }, {
    history
  });
}